import { BlogSection } from '@/types/blog';

export const buch_empfehlung: BlogSection = {
  id: 'buch-empfehlung',
  title: 'Buchempfehlung: „Die Kunst, über Geld nachzudenken"',
  content: `
    <p>Das Buch „<strong>Die Kunst, über Geld nachzudenken</strong>" ist ein absoluter Klassiker der Börsenliteratur. Es ist jedoch entscheidend, mit der richtigen Erwartungshaltung an die Lektüre zu gehen. Es handelt sich nicht um einen praktischen Schritt-für-Schritt-Ratgeber, der Ihnen sagt, welche Aktien oder ETFs Sie kaufen sollen.</p>

    <div class="bg-gradient-to-br from-joerg-50 to-primary/10 p-8 rounded-2xl my-10 border border-joerg-200">
      <h4 class="text-xl font-bold text-joerg-800 mb-6 text-center">📚 Was Sie von diesem Buch erwarten können</h4>
      
      <div class="grid md:grid-cols-2 gap-6">
        <div class="space-y-4">
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span class="text-green-600 text-sm font-bold">✓</span>
            </div>
            <div>
              <h5 class="font-semibold text-joerg-800">Zeitlose Weisheiten</h5>
              <p class="text-sm text-joerg-600">Prinzipien, die auch nach Jahrzehnten noch relevant sind</p>
            </div>
          </div>
          
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span class="text-green-600 text-sm font-bold">✓</span>
            </div>
            <div>
              <h5 class="font-semibold text-joerg-800">Amüsante Anekdoten</h5>
              <p class="text-sm text-joerg-600">Lebendige Erzählungen aus 70 Jahren Börsenerfahrung</p>
            </div>
          </div>
          
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span class="text-green-600 text-sm font-bold">✓</span>
            </div>
            <div>
              <h5 class="font-semibold text-joerg-800">Psychologische Einblicke</h5>
              <p class="text-sm text-joerg-600">Verständnis für Marktpsychologie und menschliches Verhalten</p>
            </div>
          </div>
        </div>
        
        <div class="space-y-4">
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span class="text-amber-600 text-sm font-bold">!</span>
            </div>
            <div>
              <h5 class="font-semibold text-joerg-800">Keine konkreten Tipps</h5>
              <p class="text-sm text-joerg-600">Keine spezifischen Aktienempfehlungen oder ETF-Vorschläge</p>
            </div>
          </div>
          
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span class="text-amber-600 text-sm font-bold">!</span>
            </div>
            <div>
              <h5 class="font-semibold text-joerg-800">Keine Schritt-für-Schritt-Anleitung</h5>
              <p class="text-sm text-joerg-600">Vermittelt Haltung und Denkweise, keine praktischen Handlungsschritte</p>
            </div>
          </div>
          
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span class="text-amber-600 text-sm font-bold">!</span>
            </div>
            <div>
              <h5 class="font-semibold text-joerg-800">Historischer Kontext</h5>
              <p class="text-sm text-joerg-600">Manche Beispiele stammen aus vergangenen Börsenepochen</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p>Der Wert des Buches liegt in seiner <strong>Weisheit und den psychologischen Einblicken</strong>. Es ist eine „Schule des Denkens", die die entscheidende psychologische Komponente liefert, die in vielen zahlenbasierten Finanzbüchern fehlt. Das Buch ist eine exzellente Ergänzung zu moderner Finanzliteratur und sollte in der Bibliothek eines jeden ernsthaften Anlegers seinen Platz finden.</p>

    <div class="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 p-8 rounded-2xl my-10">
      <h4 class="text-xl font-bold text-joerg-800 mb-6 text-center">🏪 Support Your Local Dealer</h4>
      
      <p class="text-joerg-700 mb-6 text-center">Ich empfehle Ihnen, das Buch bei Ihrem lokalen Buchhändler zu erwerben. Als Beispiel hier der Link zu Genniges Bücher, meinem lokalen Buchhändler:</p>
      
      <div class="bg-white border border-joerg-200 p-6 rounded-lg">
        <div class="text-center mb-4">
          <h5 class="font-semibold text-joerg-800 mb-2">André Kostolany: Die Kunst, über Geld nachzudenken</h5>
          <p class="text-sm text-joerg-600 mb-4">Taschenbuch • 240 Seiten • Ullstein Verlag</p>
        </div>
        
        <div class="text-center">
          <a href="https://genniges-buecher.buchhandlung.de/shop/article/26002338/andr_kostolany_die_kunst_ueber_geld_nachzudenken.html" 
             target="_blank" 
             rel="noopener noreferrer" 
             class="inline-block bg-joerg-800 dark:bg-joerg-100 text-white dark:text-joerg-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-joerg-700 dark:hover:bg-joerg-200 transition-all duration-200 shadow-lg hover:shadow-xl border-2 border-joerg-800 dark:border-joerg-100">
            Bei Genniges Bücher bestellen
          </a>
          <p class="text-xs text-joerg-500 mt-3">* Falls dieser Link nicht mehr aktiv sein sollte, suchen Sie einfach nach dem Titel bei Ihrem lokalen Buchhändler.</p>
        </div>
      </div>
    </div>

    <div class="bg-blue-50 border border-blue-200 p-6 rounded-lg my-8">
      <h4 class="font-semibold text-blue-800 mb-3">🧠 Neurowissenschaftlich betrachtet: Warum lokale Unterstützung Vertrauen schafft</h4>
      <p class="text-blue-700 mb-4">Unser Gehirn ist darauf programmiert, <strong>Authentizität und Integrität</strong> zu erkennen. Wenn ich Ihnen einen lokalen Buchhändler empfehle, anstatt einen Affiliate-Link zu verwenden, sendet das unbewusste Signale:</p>
      
      <ul class="space-y-2 text-blue-700 text-sm">
        <li>• <strong>Keine versteckten Gewinnabsichten</strong> – meine Empfehlung ist genuiner Natur</li>
        <li>• <strong>Gemeinschaftsorientierung</strong> – ich denke über den eigenen Vorteil hinaus</li>
        <li>• <strong>Langfristige Perspektive</strong> – lokale Strukturen sind nachhaltig und vertrauenswürdig</li>
        <li>• <strong>Konsistenz</strong> – meine Werte spiegeln sich in meinen Handlungen wider</li>
      </ul>
      
      <p class="text-blue-600 text-sm mt-4 italic">Diese unbewusste Vertrauensbildung ist der Grund, warum ich bewusst auf Affiliate-Marketing verzichte und stattdessen echte, wertorientierte Empfehlungen ausspreche.</p>
    </div>
  `
};